import script from "./BillingFooterV3.vue?vue&type=script&setup=true&lang=js"
export * from "./BillingFooterV3.vue?vue&type=script&setup=true&lang=js"

import "./BillingFooterV3.vue?vue&type=style&index=0&id=a311d994&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a311d994"]])

export default __exports__